import React, { useState, FunctionComponent } from "react";
import Button from "./Button";
import { fullOrderType, QuantitySelectorType } from "types";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

// icons
import Plus from "../assets/svg/plus.svg";
import Minus from "../assets/svg/minus.svg";

// componenets
import Loading from "../components/Loading";
import alphanumeric from "libs/makeIDs";

const useReduxState = () => {
  return useSelector((state: fullOrderType) => ({
    donation: state.donation,
    donationAk: state.donationAk,
    tickets: state.event.tickets,
    coupon: state.discountCode,
    upsells: state.upsells,
  }));
};

const useQuantitySelector = () => {
  const dispatch = useDispatch();
  const addTicket = (id: string) => {
    dispatch({ type: "ADD_TICKET", id });
  };
  const removeTicket = (id) => {
    dispatch({ type: "REMOVE_TICKET", id });
  };
  const updateTotal = (val) => {
    dispatch({ type: "UPDATE_TOTAL", val });
  };
  const updateDiscount = (val) => {
    dispatch({ type: "UPDATE_DISCOUNT", val });
  };
  return { addTicket, removeTicket, updateTotal, updateDiscount };
};

export const QuantitySelector: FunctionComponent<QuantitySelectorType> = (props) => {
  const [quantity, setQuantity] = useState(props.current);
  const [loading, setLoading] = useState(false);
  const { addTicket, removeTicket, updateTotal, updateDiscount } = useQuantitySelector();
  const { tickets, coupon, donationAk, donation, upsells } = useReduxState();
  const productID = props.ticketID;

  const getTickets = () => {
    let selectedTickets = [] as any;
    tickets.forEach((ticket) => {
      if (ticket.num > 0) {
        let upsellID = upsells.findIndex((upsell) => {
          return upsell.from === ticket.id && upsell.active === "on";
        });
        let ticketID = upsellID > -1 ? upsells[upsellID].to : "";
        selectedTickets.push({ id: ticket.id, num: ticket.num, upsell: ticketID });
      }
    });
    if (donationAk != "" && donation > 0) {
      selectedTickets.push({ id: donationAk, num: 1 });
    }

    return JSON.stringify(selectedTickets);
  };

  const decrement = async (productIDInput: string) => {
    if (productIDInput) {
      setLoading(true);
      removeTicket(productIDInput);
      setQuantity(quantity - 1);
      const { data } = await axios.get(`/api/checkbasket?productid=${getTickets()}&coupon=${coupon}`);
      if (data.response.BASKETTOTAL && data.response.BASKETTOTAL.GROSS) {
        updateTotal((parseFloat(data.response.BASKETTOTAL.GROSS._text) || 0).toFixed(2));
      } else {
        updateTotal((0).toFixed(2));
      }
      if (data.response.PROMOTIONAPPLIEDLIST && data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED) {
        updateDiscount(
          (parseFloat(data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED.DISCOUNT._text) * -1 || 0).toFixed(2)
        );
      } else {
        updateDiscount(0);
      }
      setLoading(false);
    }
  };

  const increment = async (productIDInput: string) => {
    if (productIDInput) {
      setLoading(true);
      addTicket(productIDInput);
      setQuantity(quantity + 1);
      const { data } = await axios.get(`/api/checkbasket?productid=${getTickets()}&coupon=${coupon}`);
      if (data.response.BASKETTOTAL && data.response.BASKETTOTAL.GROSS) {
        updateTotal((parseFloat(data.response.BASKETTOTAL.GROSS._text) || 0).toFixed(2));
      } else {
        updateTotal((0).toFixed(2));
      }
      if (data.response.PROMOTIONAPPLIEDLIST && data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED) {
        updateDiscount(
          (parseFloat(data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED.DISCOUNT._text) * -1 || 0).toFixed(2)
        );
      } else {
        updateDiscount((0).toFixed(2));
      }
      setLoading(false);
    }
  };

  return (
    <div className="quantity-selector">
      {loading === true && (
        <div className="quantity-selector__loading">
          <Loading />
        </div>
      )}
      <div className="quantity-selector__btns">
        <Button
          id={`ticket-quantity-decrement-${alphanumeric(productID.toString())}`}
          ariaLabel="Remove a ticket"
          btnType="button"
          btnClass="flex,mini,aqua"
          btnClick={() => {
            decrement(productID.toString());
          }}
          disabled={quantity === props.min}
        >
          <Minus />
        </Button>

        <div className="quantity-selector__quantity">{quantity}</div>

        <Button
          id={`ticket-quantity-increment-${alphanumeric(productID.toString())}`}
          ariaLabel="Add a ticket"
          btnType="button"
          btnClass="flex,mini,aqua"
          btnClick={() => {
            increment(productID.toString());
          }}
          disabled={quantity === props.max}
        >
          <Plus />
        </Button>
      </div>
    </div>
  );
};

export default QuantitySelector;
